import React from "react";
import cx from "classnames";
import { Button } from "../Button";
import styles from "./InputIcon.less";
export function InputIcon(props) {
  return React.createElement(Button, {
    className: cx(styles.InputIcon, props.className),
    onClick: props.onClick
  }, props.children);
}